import React, { useContext } from "react";

import { DispatchContext } from "../../../context/domain/planning/DispatchContext";
import { WeeklyContext } from "../../../context/global/WeeklyContext";
import { scopesByJob } from "../../../utils/business";

import Job from "./Job";

/**
 * Displays a list of jobs and their associated scopes.
 *
 * Renders the filtered jobs/scopes from {@link DispatchContext} (Dispatch
 * filters panel), associating each job with its scopes via scopesByJob.
 * Raw WeeklyContext jobs gate the initial render while data loads.
 *
 * @component
 * @param {void}
 * @returns {JSX.Element} The rendered component.
 */
const JobBox = () => {
  const { jobs } = useContext(WeeklyContext);
  const { filteredJobs, filteredScopes } = useContext(DispatchContext);

  const scopesPerJob = scopesByJob(filteredJobs, filteredScopes);

  return (
    jobs && (
      <>
        <div>
          {scopesPerJob.map(([job, scopes], index) => (
            <Job key={`jobbox-${job.id}-${index}`} job={job} scopes={scopes} />
          ))}
        </div>
      </>
    )
  );
};

export default JobBox;
